export const RULE_RECENCY_WINDOW_DAYS = 7;

interface RecencyInput {
  createdAt?: string | null;
  updatedAt?: string | null;
}

export interface RuleRecency {
  isNew: boolean;
  isUpdated: boolean;
}

const withinWindow = (iso: string | null | undefined, now: Date, windowDays: number): boolean => {
  if (!iso) return false;
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return false;
  return now.getTime() - then < windowDays * 86400000;
};

export const classifyRuleRecency = (
  rule: RecencyInput,
  now: Date = new Date(),
  windowDays: number = RULE_RECENCY_WINDOW_DAYS
): RuleRecency => {
  const isNew = withinWindow(rule.createdAt, now, windowDays);
  const isUpdated = !isNew && withinWindow(rule.updatedAt, now, windowDays);
  return { isNew, isUpdated };
};

export const ruleRecencyTimestamp = (rule: RecencyInput): number => {
  const created = rule.createdAt ? new Date(rule.createdAt).getTime() : 0;
  const updated = rule.updatedAt ? new Date(rule.updatedAt).getTime() : 0;
  return Math.max(created || 0, updated || 0);
};
